<div
  id="gcc-slider-superior"
  class="row"
  *ngIf="ativo"
  [style.backgroundColor]="backgroundColor"
  [style.color]="fontColor"
>
  <div
    *ngFor="let text of values"
    class="text-center col"
    [style.fontSize.px]="fontSize"
  >
    {{ text }}
  </div>
</div>
